import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AnimatePresence } from 'framer-motion'
import Header from './components/Header'
import Footer from './components/Footer'
import MobileBottomNav from './components/MobileBottomNav'
import PageTransition from './components/PageTransition'
import Home from './pages/Home'
import ProduitDetail from './pages/ProduitDetail'
import Reservation from './pages/Reservation'
import Confirmation from './pages/Confirmation'
import Admin from './pages/Admin'
import AdminFixed from './pages/AdminFixed'
import AdminLogin from './pages/AdminLogin'
import AdminSettings from './pages/AdminSettings'
import AdminReservationDetail from './pages/AdminReservationDetail'
import AdminUsers from './pages/AdminUsers'
import AdminProducts from './pages/AdminProducts'
import AdminCategories from './pages/AdminCategories'
import AdminOrders from './pages/AdminOrders'
import AdminMails from './pages/AdminMails'
import AdminFilmographie from './pages/AdminFilmographie'
import AdminBanners from './pages/AdminBanners'
import AdminPopupEvent from './pages/AdminPopupEvent'
import AdminCatalogImages from './pages/AdminCatalogImages'
import RentmanCatalogue from './pages/RentmanCatalogue'
import RentmanProduct from './pages/RentmanProduct'
import Panier from './pages/Panier'
import Checkout from './pages/Checkout'
import AuthLogin from './pages/AuthLogin'
import AuthRegister from './pages/AuthRegister'
import AuthForgotPassword from './pages/AuthForgotPassword'
import AuthResetPassword from './pages/AuthResetPassword'
import Account from './pages/Account'
import ClientReservations from './pages/ClientReservations'
import UserFavorites from './pages/UserFavorites'
import QuoteConfirmation from './pages/QuoteConfirmation'
import Contact from './pages/Contact'
import Filmographie from './pages/Filmographie'
import MentionsLegales from './pages/MentionsLegales'
import CGV from './pages/CGV'
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite'
import PageCMS from './pages/PageCMS'
import NotFound from './pages/NotFound'
import ErrorBoundary from './components/ErrorBoundary'
import RequireAdmin from './components/RequireAdmin'
import MaintenanceCheck from './components/MaintenanceCheck'
import UrlRedirects from './components/UrlRedirects'
import PopupEvent from './components/PopupEvent'
import { CatalogProvider } from './contexts/CatalogContext'
import { CartProvider } from './contexts/CartContext'

function App() {

  return (
    <ErrorBoundary>
      <CatalogProvider>
        <CartProvider>
        <MaintenanceCheck>
        <UrlRedirects />
        <div className="min-h-screen bg-gray-100 text-gray-900">
          <Header />
          
          <main className="min-h-screen pb-16 md:pb-0">
            <AnimatePresence mode="wait">
              <Routes>
                <Route path="/" element={<PageTransition><Home /></PageTransition>} />
                <Route path="/catalogue-materiels" element={<PageTransition><RentmanCatalogue /></PageTransition>} />
                <Route path="/catalogue-materiels/:categorySlug" element={<PageTransition><RentmanCatalogue /></PageTransition>} />
                <Route path="/catalogue-materiels/:categorySlug/:subCategorySlug" element={<PageTransition><RentmanCatalogue /></PageTransition>} />
                <Route path="/catalogue-location-materiel-tournage-guadeloupe/:slug" element={<PageTransition><RentmanProduct /></PageTransition>} />
                <Route path="/panier" element={<PageTransition><Panier /></PageTransition>} />
                <Route path="/checkout" element={<PageTransition><Checkout /></PageTransition>} />
                <Route path="/login" element={<PageTransition><AuthLogin /></PageTransition>} />
                <Route path="/register" element={<PageTransition><AuthRegister /></PageTransition>} />
                <Route path="/forgot-password" element={<PageTransition><AuthForgotPassword /></PageTransition>} />
                <Route path="/reset-password" element={<PageTransition><AuthResetPassword /></PageTransition>} />
                <Route path="/account" element={<PageTransition><Account /></PageTransition>} />
                <Route path="/account/reservations" element={<PageTransition><ClientReservations /></PageTransition>} />
                <Route path="/account/favorites" element={<PageTransition><UserFavorites /></PageTransition>} />
                <Route path="/quote-confirmation" element={<PageTransition><QuoteConfirmation /></PageTransition>} />
                <Route path="/filmographie" element={<PageTransition><Filmographie /></PageTransition>} />
                <Route path="/mentions-legales" element={<PageTransition><PageCMS slug="mentions-legales" /></PageTransition>} />
                <Route path="/cgv" element={<PageTransition><PageCMS slug="cgv" /></PageTransition>} />
                <Route path="/politique-confidentialite" element={<PageTransition><PageCMS slug="politique-confidentialite" /></PageTransition>} />
                <Route path="/contact" element={<PageTransition><PageCMS slug="contact" /></PageTransition>} />
                <Route path="/reservation" element={<PageTransition><Reservation /></PageTransition>} />
                <Route path="/confirmation" element={<PageTransition><Confirmation /></PageTransition>} />
                <Route path="/admin/login" element={<PageTransition><AdminLogin /></PageTransition>} />
                <Route path="/admin" element={<RequireAdmin><PageTransition><AdminFixed /></PageTransition></RequireAdmin>} />
                <Route path="/admin/products" element={<RequireAdmin><PageTransition><AdminProducts /></PageTransition></RequireAdmin>} />
                <Route path="/admin/categories" element={<RequireAdmin><PageTransition><AdminCategories /></PageTransition></RequireAdmin>} />
                <Route path="/admin/catalog/images" element={<RequireAdmin><PageTransition><AdminCatalogImages /></PageTransition></RequireAdmin>} />
                <Route path="/admin/orders" element={<RequireAdmin><PageTransition><AdminOrders /></PageTransition></RequireAdmin>} />
                <Route path="/admin/mails" element={<RequireAdmin><PageTransition><AdminMails /></PageTransition></RequireAdmin>} />
                <Route path="/admin/filmographie" element={<RequireAdmin><PageTransition><AdminFilmographie /></PageTransition></RequireAdmin>} />
                <Route path="/admin/banners" element={<RequireAdmin><PageTransition><AdminBanners /></PageTransition></RequireAdmin>} />
                <Route path="/admin/popup-event" element={<RequireAdmin><PageTransition><AdminPopupEvent /></PageTransition></RequireAdmin>} />
                <Route path="/admin/reservations/:id" element={<RequireAdmin><PageTransition><AdminReservationDetail /></PageTransition></RequireAdmin>} />
                <Route path="/admin/users" element={<RequireAdmin><PageTransition><AdminUsers /></PageTransition></RequireAdmin>} />
                <Route path="/admin/settings" element={<RequireAdmin><PageTransition><AdminSettings /></PageTransition></RequireAdmin>} />
                <Route path="*" element={<PageTransition><NotFound /></PageTransition>} />
              </Routes>
            </AnimatePresence>
          </main>
          
          <Footer />
          
          <MobileBottomNav />
          
          <PopupEvent />
          
          <Toaster
            position="top-center"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#1a1a1a',
                color: '#fff',
                border: '1px solid #333',
                maxWidth: '90vw',
                margin: '0 auto',
                fontSize: '14px',
                padding: '12px 16px',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
              },
              success: {
                style: {
                  border: '1px solid #ff9b05',
                },
              },
              error: {
                style: {
                  border: '1px solid #ef4444',
                },
              },
            }}
          />
        </div>
        </MaintenanceCheck>
        </CartProvider>
      </CatalogProvider>
    </ErrorBoundary>
  )
}

export default App
